import { DEFAULT_RETURN_PATH } from "@shared/constants";

export const getSafeRedirect = (returnPath?: string | null): string => {
  let redirect = DEFAULT_RETURN_PATH;
  if (returnPath) {
    try {
      const result = new URL(returnPath, window.location.origin);
      if (
        result.origin === window.location.origin &&
        (result.protocol === "http:" || result.protocol === "https:")
      ) {
        redirect = returnPath;
      }
    } catch (e) {
      // Noop
    }
  }
  return redirect;
};
